/**
 * Section sub-navigation strip — the row of links under the topbar that the
 * admin and team layouts render above their pages. Styling lives in
 * `.subnav` (index.css).
 */
import { NavLink } from "react-router-dom";
import { clsx } from "clsx";

export interface SubNavItem {
  to: string;
  label: string;
  end?: boolean;
  /** Items waiting in that section; hidden when 0 or unknown. */
  count?: number | null;
}

export function SubNav({
  items,
  ariaLabel,
}: {
  items: SubNavItem[];
  ariaLabel: string;
}) {
  return (
    <nav className="subnav" aria-label={ariaLabel}>
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          className={({ isActive }) => clsx(isActive && "is-active")}
        >
          {item.label}
          {item.count ? <span className="subnav-count">{item.count}</span> : null}
        </NavLink>
      ))}
    </nav>
  );
}
